import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";
import EnquiryForm from "../Enquiryform"; // Ensure this file path is correct.

const LandingHeader: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-between items-center w-full  mx-auto main-header component" id="home">
      {/* Overlay Section */}
      <div className="overlay flex flex-col lg:flex-row justify-around w-full items-center pt-16 lg:pb-12 lg:pt-36 lg:px-6">
        {/* Left Side: Text Content */}
        <div className="text-center lg:text-left max-w-full p-2 pt-8 lg:p-0 lg:w-1/2">
          <h1 className="text-2xl sm:text-3xl font-bold text-white component">
            Excel With{" "}
            <span
              style={{
                background:
                  "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
                padding: "0px 5px",
              }}
            >
              Matt Scholar Solutions:
            </span>
          </h1>
          <h1 className="text-1xl sm:text-2xl font-bold text-white mb-5 component">
            Trusted Online Assignment Help
          </h1>

          {/* Collapsible Content for Mobile */}
          <div
            className="container block sm:hidden pt-6 pb-8 px-3 component"
            style={{
              borderRadius: "10px",
              position: "relative",
              border: "1px solid #EE6415",
              borderBottom: "3px solid #EE6415",
            }}
          >
            <input type="checkbox" id="ch" />
            <p className="text-base font-normal leading-6 text-white text-justify lg:pe-10">
              Experience top-tier assistance from experts for global students.
              Our dedicated team offers round-the-clock support, delivering
              outstanding and engaging projects. Simply choose your package and
              easily place orders through our platform. Our ordering process is
              straightforward: fill out a preset form for the Best Assignment
              Writing Service, describe your task and special requests, and
              leave the rest to us.{" "}
              <span style={{ fontSize: "18px" }}>......</span>
            </p>

            {/* Toggle Button */}
            <div className="main-content">
              <p className="text-sm font-normal leading-6 text-white text-justify lg:pe-10">
                {/* Full Text Content */}
                Experience top-tier assistance from experts for global students.
                Our dedicated team offers round-the-clock support, delivering
                outstanding and engaging projects...
              </p>
              <label
                htmlFor="ch"
                className="px-3 py-2 mt-3"
                style={{
                  position: "absolute",
                  borderRadius: "90%",
                  border: "none",
                  backgroundColor: "#5856d6",
                  color: "white",
                  left: "43%",
                }}
              >
                <i className="fa-solid fa-chevron-up"></i>
              </label>
            </div>
            <label
              htmlFor="ch"
              className="px-3 py-2 mt-3"
              style={{
                position: "absolute",
                borderRadius: "90%",
                border: "none",
                backgroundColor: "#5856d6",
                color: "white",
                left: "43%",
              }}
            >
              <i className="fa-solid fa-chevron-down"></i>
            </label>
          </div>

          {/* Full Content for Larger Screens */}
          <p className="text-base font-semibold hidden sm:block leading-6 text-white text-justify lg:pe-10">
          Experience top-tier assistance from experts for global
                  students. Our dedicated team offers round-the-clock support,
                  delivering outstanding and engaging projects. Simply choose
                  your package and easily place orders through our platform. Our
                  ordering process is straightforward: fill out a preset form
                  for the Best Assignment Writing Service, describe your task
                  and special requests, and leave the rest to us. We edit,
                  proofread, and compose dissertations, essays, and assignments,
                  tailoring them to your instructions for excellent results.{" "}
                  <br />
                  <br />
                  Moreover, we continuously strive to improve and innovate our
                  services to meet the evolving needs of students worldwide. We
                  offer a variety of flexible packages and pricing options to
                  accommodate different budgets and academic levels. Our
                  commitment to transparency ensures that you know exactly what
                  to expect, with no hidden fees or surprises. We also provide a
                  secure and confidential service, protecting your personal
                  information and maintaining the highest standards of academic
                  integrity. With us, you can confidently achieve your academic
                  goals, knowing you have a reliable partner dedicated to your
                  success.
          </p>

          {/* WhatsApp Button */}
          <div className="mt-8 sm:mt-5 flex justify-center sm:justify-start">
            <button className="bg-green-500 text-white border-none px-4 py-2 rounded-full cursor-pointer text-base hover:bg-green-700">
              <a href="https://wa.me/918547486582">
                <div className="flex">
                  <IoLogoWhatsapp
                    className="me-1"
                    style={{ height: "30px", width: "30px" }}
                  />
                  <span className="mt-0.5 font-semibold">WhatsApp Now</span>
                </div>
              </a>
            </button>
          </div>
        </div>

        {/* Right Side: Enquiry Form */}
        <div className="shadow-2xl sm:shadow-none p-3 lg:p-0 rounded-lg component">
          <EnquiryForm />
        </div>
      </div>
    </div>
  );
};

export default LandingHeader;
